/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SortLabelsRequestLabelsInnerFromJSON(json) {
    return SortLabelsRequestLabelsInnerFromJSONTyped(json, false);
}
export function SortLabelsRequestLabelsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        sort: json['sort']
    };
}
export function SortLabelsRequestLabelsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        sort: value.sort
    };
}
